module.exports = __webpack_public_path__ + "media/images/emblems/Hoechstetten-coat_of_arms-0fb2fc4e29a7268fbc232e83c37b33d3.svg";